"use client";

import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function RemodelingCta() {
  return <section id="remodelingctaband" data-nav="dark" className="relative bg-secondary text-secondary-foreground py-20 overflow-hidden">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col items-center">
          {/* Architectural Gold Accent Hairline */}
          <div aria-hidden="true" className="w-16 h-0.5 bg-primary mb-6 rounded-full" />

          {/* Heading */}
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-secondary-foreground mb-4">
            Plan your Brookhaven interior remodel
          </h2>

          {/* Supporting Sentence */}
          <p className="text-base sm:text-lg text-secondary-foreground/80 max-w-xl mx-auto mb-8 font-default leading-relaxed">
            Schedule a personal consultation with our team and receive a clear,
            comprehensive estimate for your project.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
            <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg shadow-sm font-medium px-6 py-2.5 h-auto">
              <Link to="/ContactRequestAnEstimatePage">
                Get a Free Estimate
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-secondary-foreground/30 bg-transparent text-secondary-foreground hover:bg-secondary-foreground/10 hover:text-secondary-foreground rounded-lg px-6 py-2.5 h-auto transition-colors">
              <a href="tel:+14708479076" className="inline-flex items-center gap-2">
                <Phone className="size-4 shrink-0 text-primary" aria-hidden="true" />
                <span>Call (470) 847-9076</span>
              </a>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}